import { render, staticRenderFns } from "./UpdateStockChild.vue?vue&type=template&id=562c859b&scoped=true"
import script from "./UpdateStockChild.vue?vue&type=script&lang=js"
export * from "./UpdateStockChild.vue?vue&type=script&lang=js"
import style0 from "./UpdateStockChild.vue?vue&type=style&index=0&id=562c859b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c859b",
  null
  
)

export default component.exports